
import { Component, Vue } from 'vue-property-decorator'
import { Action, State } from 'vuex-class'
import JoinSteps from './JoinSteps.vue'
@Component({
  components: {
    JoinSteps,
  },
})
export default class Layout extends Vue {
  @State userInfo!: object
  @Action fetchLogout!: Function

  async doLogout() {
    await this.fetchLogout(() => {
      this.$message.success('已退出登录')
      this.$router.push({ path: '/' })
    })
  }
}
